import React from "react";
import { Button, Modal } from "react-bootstrap";
import InfoIcon from "../../assets/images/info.gif";
import "./ConfirmationPopup.scss";

interface ConfirmationPopupProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  show: boolean;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  message,
  onConfirm,
  onCancel,
  show,
}) => {
  return (
    <Modal show={show} onHide={onCancel} backdrop="static" centered>
<Modal.Header closeButton>
  <div className="w-100 text-center">
    <Modal.Title>Confirmation</Modal.Title>
  </div>
</Modal.Header>
      <Modal.Body>
     <div className="text-center"> <img src={InfoIcon} alt="Info Icon" className="confirmation-icon" />
        <p>{message}</p></div>
      </Modal.Body>
      <Modal.Footer>
      <div className="text-center w-100">  
        <Button className="save-btn" onClick={onConfirm}>
          Ok
        </Button>
        <Button className="back-btn" onClick={onCancel}>
          Cancel
        </Button></div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationPopup;
